import { render, staticRenderFns } from "./sdklist.vue?vue&type=template&id=451d91ca&"
import script from "./sdklist.vue?vue&type=script&lang=js&"
export * from "./sdklist.vue?vue&type=script&lang=js&"
import style0 from "./sdklist.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports